const config = {
  lilicast: {
    server: process.env.REACT_APP_LILICAST_SERVER,
  }
};

export default config;
